<template>
  <div class="container my-3 my-md-5">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h4 class="panel-heading mb-4">Eingangsporto Kalk erstellen</h4>
            <b-form-group label-cols="3" label="Name">
              <b-form-input
                  v-model="name"
                  size="md"
                  class="">
              </b-form-input>
            </b-form-group>
            <div class="w-100 d-flex">
              <div class="col-6 pl-0">
                <b-form-group label-cols="6" class="" label="Normales Gewicht berücksichtigen">
                  <b-form-checkbox
                      v-model="useWeight"
                      :value="1"
                      :unchecked-value="0"
                  ></b-form-checkbox>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group label-cols="7" class="" label="Volumengewicht berücksichtigen">
                  <b-form-checkbox
                      v-model="useVolumeWeight"
                      :value="1"
                      :unchecked-value="0"
                  ></b-form-checkbox>
                </b-form-group>
              </div>
            </div>
            <b-form-group label-cols="3" label="Preis pro Kilo">
              <b-form-input
                  v-model="kiloPrice"
                  size="md"
                  class="">
              </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Zoll">
              <b-form-input
                  v-model="customs"
                  size="md"
                  class="">
              </b-form-input>
            </b-form-group>
            <b-btn variant="primary" class="float-right" @click="createDeliveryGroup()">Speichern</b-btn>
          </div>
        </div>
      </div>
    </div>
    <modal-error-component v-model="modalError"></modal-error-component>
  </div>
</template>

<script>
export default {
  name: "DeliveryGroupCreate",
  data(
  ) {
    return {
      name: "",
      useWeight: 0,
      useVolumeWeight: 0,
      kiloPrice: 0.0,
      customs: 0.0,
      modalError: {
        show: false,
        message: '',
        error: '',
        title: ''
      },
    };
  },
  methods: {
    createDeliveryGroup() {

      const payload = {
        name: this.name,
        useWeight: this.useWeight,
        useVolumeWeight: this.useVolumeWeight,
        kiloPrice: this.kiloPrice,
        customs: this.customs,
      }
      axios.post("/deliverygroup", payload )
      .then(() => {
        this.$bvToast.toast("Erfolgreich erstellt", {
          autoHideDelay: 3000,
          variant: "success",
        })
        setTimeout(() => {
          window.location.href = '/deliverygroup';
        }, 3000);
      }).catch(error => {
        this.modalError = {
          show: true,
          message: 'Ein Fehler ist aufgetreten',
          error: error.response?.data?.message ?? error.response?.data ??  error.message ?? error,
          title: 'Erstellen fehlgeschlagen'
        };
      });
    }
  },
}
</script>